import React from "react";
import { range } from "range";
import ct from "class-types.macro";
import StarIcon from "./StarIcon";
const sizes = {
  small: ct("h-3", "w-3"),
  base: ct("h-4", "w-4"),
  large: ct("h-5", "w-5"),
  extraLarge: ct("h-6", "w-6")
};
interface Props {
  rating: number;
  size?: keyof typeof sizes;
  containerClasses?: ClassTypes;
}
const starLevel = (rating: number, i: number) => {
  if (rating >= i - 0.25) {
    return "fullstar";
  }
  if (rating >= i - 0.75) {
    return "halfstar";
  }
  return "emptystar";
};
const Stars = ({
  rating,
  size = "base",
  containerClasses = ""
}: Props) => <>
    {!!rating && rating > 0 ? <div className={["inline-flex align-middle mt-[1px]", containerClasses].filter(Boolean).join(" ")} data-testid="review-rating">
        <span className="sr-only">{`Rated ${rating.toFixed(1).replace(/\.0$/, "")} out of 5 stars`}</span>
        {range(1, 6).map(i => <StarIcon level={starLevel(rating, i)} key={i} className={sizes[size]} />)}
      </div> : null}
  </>;
export default Stars;